(() => {
      const init = () => {
        const cart = document.querySelector('cart-drawer');
        if (!cart) return;
        const sync = () => {
          cart.querySelectorAll('.inventory-warning').forEach(node => {
            node.style.backgroundColor = '#F4F7FC';
            node.querySelectorAll('.message').forEach(message => message.style.setProperty('color', '#15294F', 'important'));
          });
          cart.querySelectorAll('.money-back-text').forEach(node => {
          if (/^\s*\d+[ -]DAY MONEY-BACK GUARANTEE\s*$/i.test(node.textContent)) {
            const text = '90 DAY MONEY-BACK GUARANTEE';
            if (node.textContent !== text) node.textContent = text;
          }
          });
        };
        sync();
        new MutationObserver(sync).observe(cart, { childList: true, subtree: true });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
      else init();
    })();
